var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"boolean-status",class:[_vm.value ? 'bg-apple-500' : 'bg-monza-500']})}
var staticRenderFns = []

export { render, staticRenderFns }